export default __webpack_public_path__ + "static/media/no-image.7b112280.jpg";